<template>
  <div class="filter-view">
    <ExpertFilters />

    <div class="justify-end-div">
      <div class="justify-end-search" style="gap:10px">
        <div @click="onDownload" class="download-button tooltip-container">
          <img src="../../../assets/images/downloadOutline.svg" class="row-item-icon" />
          <span class="tooltip-text">{{$t('download_as_xls')}}</span>
        </div>
        <ExpandableSearch :searchText="searchText" />
      </div>

      <div class="justify-end-add-btn no-text-select" @click="addNewUser">
        <img src="../../../assets/images/plus.svg">
        <span>{{$t('add_new')}}</span>
      </div>
    </div>

  </div>

  <div class="table-container">
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th><input type="checkbox"></th>
        <th @click="handleSort('name')" class="sortable-header">
          {{$t('name_payment')}}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('name')"
          >
        </th>
        <th @click="handleSort('title')" class="sortable-header">
          {{$t('title_expert')}}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('title')"
          >
        </th>
        <th>{{$t('language_settings')}}</th>
        <th @click="handleSort('totalSessionsCount')" class="sortable-header" style="text-align: start">
          {{$t('total_programs')}}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('totalSessionsCount')"
          >
        </th>
        <th @click="handleSort('plannedSessionsCount')" class="sortable-header" style="text-align: center;justify-content: start;display: flex">
          {{$t('scheduled_status')}}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('plannedSessionsCount')"
          >
        </th>
      </tr>
      </thead>
      <tbody class="tbody-container">
      <tr class="tr-class" v-if="!loading" v-for="expert in experts" :key="expert.expertId">
        <td class="td-style"><input type="checkbox"></td>
        <td class="td-style">
          <router-link :to="'/experts/detail/' + expert.expertId" class="name-row">
            <img class="company-icon" :src="expert.avatarUrl" v-if="expert.avatarUrl" />
            <span class="test-class">{{ expert.name }} {{expert.surname}}</span>
          </router-link>
        </td>
        <td class="td-style"> <span class="test-class">{{ expert.title || '-' }}</span></td>
        <td class="td-style">
          <div class="flags">
            <template v-if="expert.languages && expert.languages.length > 0">
              <img
                  v-for="lang in expert.languages"
                  :key="lang"
                  :src="getLanguageFlag(lang)"
                  :alt="lang.toUpperCase()"
              />
            </template>
            <span v-else class="no-language">-</span>
          </div>
        </td>
        <td style="text-align: center" class="td-style">
          <span class="test-class">
            <img src="../../../assets/images/programs.svg">
            {{ expert.totalSessionsCount ?? 0 }} {{$t('programs_title')}}
          </span>
        </td>
        <td class="td-style">
          <span class="test-class">
            <img src="../../../assets/images/calendarTickGreen.svg">
            {{ expert.plannedSessionsCount ?? 0 }} {{$t('programs_title')}}
          </span>
        </td>
      </tr>
      <tr v-else>
        <td colspan="6" class="table-loading">
          <VueSpinner size="16" height="100%" color="#8c8c8c" />
          <span class="text">{{$t('loading')}}</span>
        </td>
      </tr>
      <tr v-if="!loading && experts.length === 0 ">
        <td colspan="6" class="table-loading">
          <span class="text">{{$t('no_data_found')}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AddUserModal from '@/components/modals/InviteUserModal.vue';
import FilterModal from '@/components/tables/Company/CompanyFilterModal.vue';
import CompanyFieldFilter from '@/components/table-filters/CompanyFieldFilter.vue';
import ProgramFilter from "@/components/table-filters/NumberFilter.vue";
import UserAmountFilter from "@/components/table-filters/MinMaxNumberFilter.vue";
import PaymentVolume from "@/components/table-filters/PaymentVolume.vue";
import DateFilter from "@/components/table-filters/DateFilter.vue";
import {VueSpinner} from "vue3-spinners";
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import ExpertFilters from "@/components/tables/Expert/ExpertFilters.vue";
import languages from "@/lang/languages.json";

export default {
  components: {
    ExpertFilters,
    DateFilter,
    PaymentVolume,
    UserAmountFilter,
    AddUserModal,
    FilterModal,
    CompanyFieldFilter,
    ProgramFilter,
    ExpandableSearch,
    VueSpinner
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    addNewUser: {
      type: Function,
      default: () => {}
    },
    experts: {
      type: Array,
      default: []
    },
    currentSort: {
      type: Object,
      default: () => ({ column: null, direction: null })
    },
    onSort: {
      type: Function,
      required: false,
      default: () => {}
    },
    onDownload: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      showModal: false,
      selectAll: false,
      showFilter: false,
      searchText: '',
    }
  },
  methods: {
    handleSort(column) {
      let newDirection = 'asc';

      // Eğer aynı kolona tıklanıyorsa direction'ı değiştir
      if (this.currentSort.column === column) {
        if (this.currentSort.direction === 'asc') {
          newDirection = 'desc';
        } else if (this.currentSort.direction === 'desc') {
          // desc'den sonra sıralamayı kaldır
          this.onSort(null, null);
          return;
        }
      }

      this.onSort(column, newDirection);
    },

    getSortClass(column) {
      if (this.currentSort.column !== column) {
        return 'sort-default';
      }

      if (this.currentSort.direction === 'asc') {
        return 'sort-asc';
      } else if (this.currentSort.direction === 'desc') {
        return 'sort-desc';
      }

      return 'sort-default';
    },

    getLanguageFlag(lang) {
      const language = lang.toLowerCase();
      let flag = languages.en.find(l => l.value === lang).flag ?? null;
      return `/flags/${flag}.svg`;
    }
  },
}
</script>

<style>
.sortable-header {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.sortable-header:hover {
  background-color: #f5f5f5;
}

.sort-icon {
  width: 16px;
  height: 16px;
  margin-left: 4px;
  vertical-align: middle;
  transition: transform 0.3s ease, opacity 0.3s ease;
  display: inline-block;
  opacity: 0.4;
}

.sortable-header:hover .sort-icon {
  opacity: 0.6;
}

.sort-icon.sort-asc,
.sort-icon.sort-desc {
  opacity: 1;
}

.sort-icon.sort-asc {
  transform: rotate(0deg);
}

.sort-icon.sort-desc {
  transform: rotate(180deg);
}

.sort-icon.sort-default {
  transform: rotate(0deg);
  opacity: 0.4;
}

.filter-view{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
  min-height: 52px;
}
.justify-end-div{
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: center;
}
.justify-end-search{
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  border-radius: 8px;
  padding: 8px;
}

.company-icon {
  height: 32px;
  width: 32px;
  border-radius: 50%;
}

.show-filters{
  font-family: euclid_medium, sans-serif;
  color: #4A68F8;
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
}

.row-item-icon {
  height: 16px;
  width: 16px;
}

.name-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.name-row span {
  font-family: euclid_medium, sans-serif;
  color: #000;
}

.name-row:hover.name-row span{
  color: #4A68F8;
}

.flags {
  display: flex;
  align-items: center;
  gap: 5px;
}

.flags img {
  height: 18.66px;
  width: 28px;
  border-radius: 4px;
}

.no-language {
  color: #98A2B3;
  font-size: 14px;
}

.category-tag {
  margin-right: 5px;
}

.header-table th {
  padding: 12px 16px;
  white-space: nowrap;
  min-width: 120px;
  position: relative;
}

.header-table th:first-child {
  min-width: 50px;
  width: 50px;
}

.header-table th:nth-child(2) {
  min-width: 200px;
}

.header-table th:nth-child(4) {
  min-width: 100px;
  text-align: left;
}

.header-table th:nth-child(5) {
  min-width: 150px;
}

.header-table th:nth-child(5) img {
  margin-left: 8px;
  vertical-align: middle;
}

.header-table th:nth-child(6) {
  min-width: 160px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-table th:last-child {
  min-width: 140px;
}

.table-container {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 992px) {
  .header-table th {
    padding: 10px 12px;
    font-size: 11px;
  }

  .header-table th img {
    width: 14px;
    height: 14px;
  }
}
</style>
